import type {CustomerLogo} from '@/ui/logos-carousel';

export const LOGO_BASE = '/static/images/industry-professional-services/customer-logos';

/** `file` matches basename in customer-logos/ (without .png). */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  {file: 'Adia-logo_2x', label: 'Adia', width: 189, height: 80},
  {file: 'Boulay-logo_2x', label: 'Boulay', width: 212, height: 80},
  {file: 'Bradymartz-logo_2x', label: 'Brady Martz', width: 336, height: 80},
  {file: 'Controlrisks_2x', label: 'Control Risks', width: 317, height: 80},
  {file: 'CPM-logo_2x', label: 'CPM', width: 203, height: 80},
  {file: 'ICBD-logo_2x', label: 'ICBD', width: 210, height: 80},
  {file: 'IPG-logo_2x', label: 'IPG', width: 364, height: 80},
  {file: 'Kaufman-logo_2x', label: 'Kaufman', width: 141, height: 80},
  {file: 'Kubicki-logo_2x', label: 'Kubicki', width: 119, height: 80},
  {file: 'Lafosse-logo_2x', label: 'La Fosse', width: 207, height: 80},
  {file: 'LGI-logo_2x', label: 'LGI', width: 231, height: 80},
  {file: 'LRN-logo_2x', label: 'LRN', width: 211, height: 80},
  {file: 'Mcdonaldmiller-logo_2x', label: 'McDonald Miller', width: 191, height: 80},
  {file: 'Mediabar-logo_2x', label: 'MediaBar', width: 306, height: 80},
  {file: 'Methods-logo_2x', label: 'Methods', width: 267, height: 80},
  {file: 'P3-logo_2x', label: 'P3', width: 341, height: 80},
  {file: 'Resourceinnovations-logo_2x', label: 'Resource Innovations', width: 313, height: 80},
  {file: 'Resourcemanagement-logo_2x', label: 'Resource Management', width: 228, height: 80},
  {file: 'Teleperformance-logo_2x', label: 'Teleperformance', width: 346, height: 80},
  {file: 'Theofficegroup-logo_2x', label: 'The Office Group', width: 366, height: 80}
];
